import * as z from 'zod';

import type {ProductColorFragment} from '@/modules/commerce/product-color/query';

export const productColorConfigurationSchema = z.string();

export type ProductColorConfiguration = z.infer<typeof productColorConfigurationSchema>;

export function getDefaultProductColorConfiguration(
	_colors: ProductColorFragment[],
): ProductColorConfiguration | null {
	return null;
}

export function productColorConfigurationFromFormData(
	options: ProductColorFragment[],
	namePrefix: string,
	formData: FormData,
): ProductColorConfiguration | null {
	let config: ProductColorConfiguration | null = null;

	const colorId = formData.get(`${namePrefix}`);
	for (const option of options) {
		if (option._id === colorId) {
			config = option._id;
			break;
		}
	}

	return config;
}
